import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Privacy from "./legal/Privacy.tsx";
import Terms from "./legal/Terms.tsx";

function LegalOverview() {
  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-4xl font-bold text-slate-900 dark:text-white mb-8">Legal Information</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white dark:bg-slate-800 rounded-lg p-6 shadow-sm border border-slate-200 dark:border-slate-700">
          <h3 className="text-xl font-semibold text-slate-900 dark:text-white mb-3">Terms of Service</h3>
          <p className="text-slate-600 dark:text-slate-400 mb-4">
            Review our terms and conditions for using Lavender Flow.
          </p>
          <a href="/legal/terms" className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 font-medium">
            Read Terms →
          </a>
        </div>
        <div className="bg-white dark:bg-slate-800 rounded-lg p-6 shadow-sm border border-slate-200 dark:border-slate-700">
          <h3 className="text-xl font-semibold text-slate-900 dark:text-white mb-3">Privacy Policy</h3>
          <p className="text-slate-600 dark:text-slate-400 mb-4">
            Learn how we collect, use, and protect your personal information.
          </p>
          <a href="/legal/privacy" className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 font-medium">
            Read Privacy Policy →
          </a>
        </div>
      </div>
    </div>
  );
}

export default function Legal() {
  return (
    <Routes>
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/" element={
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 dark:from-slate-900 dark:to-slate-800">
          <Header variant="default" />
          <div className="container mx-auto px-4 py-16">
            <LegalOverview />
          </div>
          <Footer />
        </div>
      } />
    </Routes>
  );
}
